import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import image from "../../assets/home.jpg";
import { useNavigate } from "react-router-dom";
import {
  childVariants,
  containerVariants,
} from "../../components/auth/signup/motion";
import Navbar from "../../components/auth/common/Navbar";

const Auth = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1020);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      className={`flex items-center justify-center h-screen select-none ${
        isSmallScreen ? "bg-cover bg-center" : ""
      }`}
      style={{ backgroundImage: isSmallScreen ? `url(${image})` : "none" }} // Set background image for small screens
    >
      <Navbar />
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="w-[90%] h-[80vh] lg:h-max lg:w-max bg-white/90 flex flex-row justify-center items-center border border-[#CBD5E1] rounded-[10px] shadow-custom overflow-hidden mt-12"
      >
        <motion.div
          variants={childVariants}
          className="hidden lg:block w-[375px] 2xl:w-[600px] h-[412px] overflow-hidden"
        >
          <img
            src={image}
            alt="login"
            loading="lazy"
            className="w-full h-full object-cover"
          />
        </motion.div>

        <motion.div
          variants={childVariants}
          className="flex flex-col w-[300px] md:w-[400px] 2xl:w-[500px] gap-3 p-8"
        >
          <motion.div
            variants={childVariants}
            className="flex flex-col items-center"
          >
            <h2 className="text-lg text-gray-800 text-center">
              Welcome! We&rsquo;re thrilled to have you on board!
            </h2>
          </motion.div>
          <motion.div
            className="flex items-center justify-center flex-col gap-4"
            variants={childVariants}
          >
            <motion.div variants={childVariants} className="font-medium">
              Let&rsquo;s Get Started
            </motion.div>
            <button
              onClick={() => navigate("/signup")}
              className="w-48 py-2 text-base text-white bg-[#036494] rounded-full"
            >
              Register
            </button>
            <motion.div
              variants={childVariants}
              className="text-sm text-nowrap"
            >
              Already have an account ?{" "}
              <span
                onClick={() => navigate("/login")}
                className=" cursor-pointer font-medium"
              >
                Log in
              </span>
            </motion.div>
          </motion.div>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default Auth;
